export enum MessageAuthor {
    Agent,
    User,
}
